a.s = (function(){
	var my = {
		createToken:function(){
			return Math.random().toString(36).substr(2);
		}
	};
	return my;
}());